<template>
  <div>
    <MasterPage>
      <template v-slot:content>
        <CopackerFacilities />
        <GlobalFooter>
          <div class="legalese">
            The information contained in this copacker directory is provided for
            informational purposes only and we disclaim any responsibility or
            liability with respect to the products and information contained
            here. All information is provided without any warranties of any kind
            either expressed or implied, to the fullest extent permissible under
            applicable law
          </div>
        </GlobalFooter>
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import CopackerFacilities from "./CopackerFacilities.vue";
import MasterPage from "../MasterPage.vue";
import { useMainStore } from "@/stores/useMainStore";
import GlobalFooter from "@/views/GlobalFooter.vue";

const main = useMainStore();
</script>
